import React from 'react'
import { connect } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import {
  AddCard,
  AdditionalFields,
  Footer,
  Header,
  Loader,
  PaymentFields,
} from '../components'
import withRouter from '../HOC/widthRouter'
import { baseURL } from '../http'
import { GuestActionCreators } from '../redux/reducers/guest/action-creators'
import { Languages } from '../redux/reducers/language/languageData'

import { ServiceActionCreators } from '../redux/reducers/service/action-creators'
import { fetchWithTimeout } from '../utils/query'

import { getQueryParams } from '../utils/query'

import '../styles/components/Service.scss'

import GooglePayButton from '@google-pay/button-react'
import { getMobileOperatingSystem, getSplittedCardExpiryDate, isSafari } from '../utils/functions'

import googlePayLoader from '../assets/google-pay.svg'
import { BrowserTokenActionCreators } from '../redux/reducers/browserToken/action-creators'
import ReCAPTCHA from 'react-google-recaptcha'
import Tokenize from '../services/tokenize'

const cardSelectorCategories = new Set([9, 5, 10, 16])
const cardSelectorServices = new Set([1069])

const MOBILE_DEVICE = getMobileOperatingSystem()

class Service extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      previousLang: undefined,
      fields: [],
      groupId: 0,
      isClientExist: false,
      allFieldsHaveData: false,
      isLoading: false,
      isModalVisible: false,
      amountValue: '',
      webcam: false,
      msgType: 0,
      subVal: '',
      autoRedirectToPayment: false,
      subName: '',
      additionalDebtFields: [],
      isAmountCorrect: true,
      fieldsForPicker: [
        { label: 'Visa', key: 'newcard_visa', value: 'newcard_visa' },
        { label: 'MasterCard', key: 'newcard_mc', value: 'newcard_mc' },
      ],
      cardPanId: 'newcard_visa',
      loadingNotTransparent: false,
      debtCurrency: '',
      googlePayButtonLoad: true,
      recaptcha: null,
      recaptchaLoader: true,
      cardData: null
    }
  }

  componentDidMount = async () => {
    function detectWebcam(callback) {
      let md = navigator.mediaDevices
      if (!md || !md.enumerateDevices) return callback(false)
      md.enumerateDevices().then(devices => {
        callback(devices.some(device => 'videoinput' === device.kind))
      })
    }
    detectWebcam(hasWebcam => {
      this.setState({ webcam: hasWebcam })
    })

    const { params, getServiceById } = this.props

    await getServiceById({
      selected: [+params?.id],
      hash: +params?.id,
    })
  }

  notify = message => {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)

    const msgType = {
      0: language.someError,
      1: language.noClientMsg,
      2: language.recaptchaError,
    }

    toast.error(message || msgType[this.state.msgType], {
      position: toast.POSITION.TOP_CENTER,
    })
  }

  notifyWebcamError = () => {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)
    toast.error(language.notWebcam, {
      position: toast.POSITION.TOP_CENTER,
    })
  }

  componentDidUpdate = async (_, prevS) => {
    if (prevS.allFieldsHaveData !== this.state.allFieldsHaveData) {
      if (this.state.allFieldsHaveData) {
        await this.onButtonPress()
      }
    }
    if (this.state.autoRedirectToPayment !== prevS.autoRedirectToPayment) {
      if (this.state.autoRedirectToPayment) {
        await this.onButtonPress()
      }
    }
  }

  async checkIfUserExist(serviceId, fields, selectedGroupId) {
    this.setState({ isLoading: true })
    try {
      const requestHeaders = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Payment-Origin': 'frames',
      }

      if (this.props?.service?.captcha > 0) {
        requestHeaders['Captcha'] = this.state.recaptcha || ''
      }

      const response = await fetchWithTimeout(
        `${baseURL}/guest/categories/client_info_with_group_id?fields=${encodeURIComponent(
          fields,
        )}&selectedGroupId=${selectedGroupId}&serviceId=${serviceId}`,
        {
          method: 'GET',
          headers: requestHeaders,
        },
      )
      if (response.status === 200) {
        const json = await response.json()
        if (json.resultCodes !== 'OK') {
          this.setState({ allFieldsHaveData: false })
        }
        if (json.resultCodes === 'OK') {
          if (!isSafari() || MOBILE_DEVICE === 'Android') {
            const { data } =
              await this.props.getBrowserToken({
                parameters: 'G-PAY',
                serviceId: serviceId,
                tokenType: 3,
              });
            this.setState({ isClientExist: true, checkData: json, gpayMerhant: data.browserToken })
          } else {
            this.setState({ isClientExist: true, checkData: json })
          }
        } else if (
          json.resultCodes === 'NOT_FOUND' ||
          json.resultCodes === 'CUSTOMER_NOT_FOUND' ||
          json.resultCodes === 'INVALID_PARAMETERS' ||
          json.resultCodes === 'UNKNOWN_ERROR'
        ) {
          this.setState({ msgType: 1 })
          this.notify()
        } else if (
          json.resultCodes === 'UNDECIDED_PROTOCOL' ||
          json.resultCodes === 'PROTOCOL_CANT_DECIDED'
        ) {
          this.setState({ showVerdictFields: true })
        } else if (json.resultCodes === 'RECAPTCHA_ERROR') {
          this.setState({ msgType: 2 })
          this.notify()
        } else {
          this.setState({ msgType: 0 })
          this.notify()
        }
      } else {
        this.setState({ msgType: 0 })
        this.notify()
      }
    } catch (e) {
      this.setState({ msgType: 0 })
      this.notify()
    } finally {
      this.setState({ isLoading: false })
    }
  }


  isHubSolutionPaymentMethod = ()=> {
    const { availablePaymentSystem } = this.props.service

    let isHubSolutionPaymentMethod = false

    availablePaymentSystem.forEach((item)=>{
      if(item.paymentSystem==="HUB_SOLUTION" && item.paymentProcessor === "HUB_SOLUTION") {
        isHubSolutionPaymentMethod  = true
        return
      }
    })


    return isHubSolutionPaymentMethod
  }

  async onButtonPress(e) {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)

    e?.preventDefault()
    const { service } = this.props
    const { fields, groupId, subName, subVal, cardPanId } = this.state
    const fieldsJSON = JSON.stringify({ fields })
    if (this.props.loading.isPaymentLoading) {
      return
    }
    if (this.state.isClientExist) {
      let loading = false
      if (this.state.isAmountCorrect || Number(this.state.paramAmountValue)) {
        let { language = 'az' } = getQueryParams()

        this.setState({ isLoading: true })

        try {
          loading = true
          if(this.isHubSolutionPaymentMethod()) {
            const { cardData } = this.state

            const { cardNumber, cvc, expiryDate } = cardData

            const { month, year } = getSplittedCardExpiryDate(expiryDate)

            const CardData = {
              CardHolder: "E-pul",
              Pan: cardNumber,
              Cvv2: cvc,
              ExpiryMonth: +month,
              ExpiryYear: +year,
            }

            console.log(`CardData:`, CardData)

            console.log(`this.props.browserToken:`, this.props.browserToken)


            const { data } = await this.props.getBrowserToken({})

            const {data:{cardToken}} = await Tokenize.tokenize({
              body: {
                CardData,
              },
              headers: {
                BrowserToken: data.browserToken,
              },
            })

            const url = await this.props.doGuestPay(
              service.id,
              this.state.paramAmountValue
                ? Number(this.state.paramAmountValue)
                : Number(this.state.amountValue),
              fieldsJSON,
              false,
              subName,
              subVal,
              groupId || 0,
              `${window.location.origin}/frames/${language}/check`,
              cardToken,
              4
            )

            console.log(`url:`, url)


            if (url) {
              window.location = url
            } else {
              throw new Error()
            }

          } else {
            const url = await this.props.doGuestPay(
              service.id,
              this.state.paramAmountValue
                ? Number(this.state.paramAmountValue)
                : Number(this.state.amountValue),
              fieldsJSON,
              false,
              subName,
              subVal,
              groupId || 0,
              `${window.location.origin}/frames/${language}/check`,
              cardPanId,
            )

            if (url) {
              window.location = url
            } else {
              throw new Error()
            }
          }
        } catch (e) {
          this.setState({ isLoading: false })
          loading = false
        } finally {
          if (!loading) {
            this.setState({ isLoading: false })
          } else {
            this.setState({ isLoading: true })
          }
        }
      }
    } else {
      if (!this.state.recaptcha && service?.captcha > 0) {
        this.notify(language.recaptchaError)
        return
      }

      this.checkIfUserExist(service.id, fieldsJSON, groupId || 0)
    }
  }

  renderPicker() {
    const { language: selectedLanguage } = this.props.language
    const language = Languages(selectedLanguage)
    return (
      <div className='service_fields-item'>
        <div className='service_fields-item-title'>{language.selectCard}</div>
        <select
          onChange={e => {
            this.setState({ cardPanId: e.target.value })
          }}
          value={this.state.cardPanId}
        >
          {this.state.fieldsForPicker.map((item, i) => {
            return (
              <option key={item.key} value={item.value}>
                {item.label}
              </option>
            )
          })}
        </select>
      </div>
    )
  }

  getGooglePayTokenizationSpecification(paymentProcessor, gpayMerhant) {
    if (!paymentProcessor) return null
    const tokenizationSpecification = {
      YIGIM: {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          gateway: 'yigim',
          gatewayMerchantId: 'EPL0001',
        },
      },
      CYBER_SOURCE: {
        type: 'PAYMENT_GATEWAY',
        parameters: {
          gateway: 'cybersource',
          gatewayMerchantId: gpayMerhant,
        },
      },
    }
    return tokenizationSpecification[paymentProcessor]
  }

  getGooglePayPaymentProcessor(availablePaymentSystem) {
    const res = availablePaymentSystem?.find(item => {
      if (item.paymentSystem === 'GOOGLE_PAY') {
        return item
      }
      return null
    })
    return res?.paymentProcessor
  }

  render() {

    console.log('this.state.cardData',this.state.cardData)

    const { language: selectedLanguage, langKey } = this.props.language
    const language = Languages(selectedLanguage)
    console.log(`language:`, language)
    console.log(`language?.language:`, language?.language)
    console.log(`recaptchaLoader:`, this.state.recaptchaLoader)

    const { service, serviceError, navigate } = this.props

    const { loadingNotTransparent } = this.state

    if (serviceError) {
      return <div className='service_error'>Ошибка при загрузке Сервиса</div>
    }

    const loader = (
      <div
        className={`loader-wrapper ${
          loadingNotTransparent ? 'loader-wrapper--not-transparent' : ''
        } `}
      >
        <Loader />
      </div>
    )

    if (Object.keys(service).length === 0) {
      return loader
    }

    const {
      isClientExist,
      checkData,
      isAmountCorrect,
      showVerdictFields,
      fieldsForPicker,
      webcam,
      gpayMerhant,
    } = this.state

    const serviceDescription =
      `<div class="service_description-field-title">${language.information}!</div>` +
      service?.localDesc?.[langKey]

    const isRightColumn =
      service?.localDesc?.[langKey] !== '' ||
      this.state.additionalDebtFields?.length !== 0

    const containerClassName = isRightColumn
      ? 'container'
      : 'container container--not-right-column'

    const amountValue = this.state?.paramAmountValue
      ? Number(this.state?.paramAmountValue)
      : Number(this.state?.amountValue)

    const { availablePaymentSystem } = service

    const GOOGLE_PAY_AVAILABLE_PAYMENT_SYSTEMS = ['GOOGLE_PAY']
    const APPLE_PAY_AVAILABLE_PAYMENT_SYSTEMS = ['APPLE_PAY']

    const GOOGLE_PAY_AVAILABLE_PAYMENT_PROCESSOR = ['YIGIM', 'CYBER_SOURCE']
    const APPLE_PAY_AVAILABLE_PAYMENT_PROCESSOR = ['YIGIM', 'CYBER_SOURCE']

    let isGooglePayBtn = false

    let isApplePayBtn = false

    availablePaymentSystem?.forEach(item => {
      if (
        GOOGLE_PAY_AVAILABLE_PAYMENT_SYSTEMS.includes(item.paymentSystem) &&
        GOOGLE_PAY_AVAILABLE_PAYMENT_PROCESSOR.includes(item.paymentProcessor)
      ) {
        isGooglePayBtn = true
      }
      if (
        APPLE_PAY_AVAILABLE_PAYMENT_SYSTEMS.includes(item.paymentSystem) &&
        APPLE_PAY_AVAILABLE_PAYMENT_PROCESSOR.includes(item.paymentProcessor)
      ) {
        isApplePayBtn = true
      }
    })

    const googlePayPaymentProcessor = this.getGooglePayPaymentProcessor(
      availablePaymentSystem,
    )

    const tokenizationSpecification =
      this.getGooglePayTokenizationSpecification(googlePayPaymentProcessor, gpayMerhant)

    console.log(`tokenizationSpecification:`, tokenizationSpecification)

    const onRecaptchaChange = value => {
      console.log(`value:`, value)
      this.setState({
        recaptcha: value,
      })
    }

    const serviceName = service.localName[langKey]
    return (
      <>
        <div className='container-wrapper'>
          <Header containerClassName={containerClassName} />
          <div className={containerClassName}>
            <div className='service-wrapper'>
              <div className='service'>
                <form
                  className='service_form'
                  onSubmit={e => {
                    this.onButtonPress(e)
                  }}
                >
                  <h1 className='service_title'>
                    {serviceName}
                  </h1>
                  <div className='service_content'>
                    <PaymentFields
                      showVerdictFields={showVerdictFields}
                      service={service}
                      onValueChange={s => this.setState(s)}
                      isClientExist={isClientExist}
                      azercell={service?.id === 976}
                      fieldsForPicker={fieldsForPicker}
                      webcam={webcam}
                      notifyWebcamError={this.notifyWebcamError}
                    />
                    {isClientExist && (
                      <>
                        <AdditionalFields
                          onChange={s => this.setState(s)}
                          isAmountCorrect={isAmountCorrect}
                          service={service}
                          checkData={checkData}
                        />
                        {(cardSelectorCategories.has(service?.categoryId) ||
                          cardSelectorServices.has(service?.id)) &&
                          this.renderPicker()}
                      </>
                    )}
                  </div>
                  {isClientExist && (
                    <div className='pay-buttons'>
                      {isGooglePayBtn &&
                        (!isSafari() || MOBILE_DEVICE === 'Android') && (
                          <div className='pay-buttons__google'>
                            {this.state.googlePayButtonLoad && (
                              <div
                                className='pay-buttons__google-loader loader'
                                disabled
                              ></div>
                            )}
                            <GooglePayButton
                              buttonLocale={selectedLanguage || 'az'}
                              onReadyToPayChange={() => {
                                this.setState({ googlePayButtonLoad: false })
                              }}
                              environment='PRODUCTION'
                              paymentRequest={{
                                apiVersion: 2,
                                apiVersionMinor: 0,
                                allowedPaymentMethods: [
                                  {
                                    type: 'CARD',
                                    parameters: {
                                      allowedAuthMethods: [
                                        'PAN_ONLY',
                                        'CRYPTOGRAM_3DS',
                                      ],
                                      allowedCardNetworks: [
                                        'MASTERCARD',
                                        'VISA',
                                      ],
                                    },
                                    tokenizationSpecification,
                                  },
                                ],
                                merchantInfo: {
                                  merchantId: 'BCR2DN4TQD7LHWQ7',
                                  merchantName: 'E-Pul',
                                },
                                transactionInfo: {
                                  totalPriceStatus: 'FINAL',
                                  totalPriceLabel: 'Total',
                                  totalPrice: amountValue?.toString(),
                                  currencyCode:
                                    this.state.debtCurrency || 'AZN',
                                  countryCode: 'AZ',
                                },
                              }}
                              onLoadPaymentData={paymentRequest => {
                                console.log(`paymentRequest:`, paymentRequest)
                                navigate(
                                  `/frames/confirmation/${service?.id}`,
                                  {
                                    state: {
                                      serviceId: service?.id,
                                      payWith: 'Google Pay',
                                      paymentRequest,
                                      serviceName: service?.localName.valueEn,
                                      mainState: this.state,
                                    },
                                  },
                                )
                              }}
                            />
                          </div>
                        )}
                      {isApplePayBtn && (
                        <div className='pay-buttons__apple'>
                          {(isSafari() || MOBILE_DEVICE === 'iOS') &&
                            window.ApplePaySession && (
                              <div
                                id='ckoApplePay'
                                class='apple-pay-button apple-pay-button-text-buy'
                                lang={selectedLanguage || 'az'}
                                onClick={() => {
                                  if (!window.ApplePaySession) {
                                    return
                                  }
                                  const request = {
                                    countryCode: 'AZ',
                                    currencyCode:
                                      this.state.debtCurrency || 'AZN',
                                    merchantCapabilities: ['supports3DS'],
                                    supportedNetworks: ['visa', 'masterCard'],
                                    total: {
                                      label: serviceName,
                                      type: 'final',
                                      amount: amountValue?.toString(),
                                    },
                                  }
                                  const session = new window.ApplePaySession(
                                    3,
                                    request,
                                  )
                                  session.onvalidatemerchant = async event => {
                                    const { data } =
                                      await this.props.getBrowserToken({
                                        parameters: `${event.validationURL};${window.location.origin}`,
                                        serviceId: service?.id,
                                        tokenType: 2,
                                      })

                                    session.completeMerchantValidation(
                                      JSON.parse(
                                        JSON.parse(data?.browserToken).token,
                                      ),
                                    )
                                  }

                                  session.onpaymentauthorized = async event => {
                                    console.log('onpaymentauthorized', event)

                                    let loading = false
                                    try {
                                      // this.setState({ isLoading: true })

                                      const tokenType = 2

                                      const url = await this.props.doGuestPay(
                                        this.props.service.id,
                                        amountValue,
                                        JSON.stringify({
                                          fields: this.state?.fields,
                                        }),
                                        false,
                                        this.state?.subName,
                                        this.state?.subVal,
                                        this.state?.groupId || 0,
                                        '',
                                        JSON.stringify(event.payment.token),
                                        tokenType,
                                      )

                                      let result = null

                                      if (url) {
                                        result = {
                                          status:
                                            window.ApplePaySession
                                              .STATUS_SUCCESS,
                                        }
                                      } else {
                                        result = {
                                          status:
                                            window.ApplePaySession
                                              .STATUS_FAILURE,
                                        }
                                      }

                                      session.completePayment(result)

                                      navigate(
                                        `/frames/${selectedLanguage}/check?orderId=${
                                          this.props.guestPayment.orderId
                                        }&tokenType=${2}`,
                                      )
                                    } catch (e) {
                                      // this.setState({ isLoading: false })
                                      // loading = false
                                      // session.onerror = event => {
                                      //   alert(event.error)
                                      // }
                                    } finally {
                                      if (!loading) {
                                        // this.setState({ isLoading: false })
                                      } else {
                                        // this.setState({ isLoading: true })
                                      }
                                    }
                                  }
                                  session.onerror = event => {
                                    alert(event.error)
                                  }
                                  session.oncancel = event => {
                                    alert('Canceled')
                                  }
                                  session.begin()
                                }}
                              ></div>
                            )}
                        </div>
                      )}
                    </div>
                  )}

                  {!isClientExist && service?.captcha > 0 && (
                    <div className='service_recaptcha'>
                      {this.state.recaptchaLoader && (
                        <div className='recaptcha-loader loader' disabled></div>
                      )}
                      <ReCAPTCHA
                        sitekey={'6LfhleMoAAAAAIKvywPzSxtTk9K50bnPVl82gncg'}
                        onChange={onRecaptchaChange}
                        hl={language?.lang}
                        asyncScriptOnLoad={() => {
                          this.setState({
                            recaptchaLoader: false,
                          })
                        }}
                      />
                    </div>
                  )}

                  {this.isHubSolutionPaymentMethod() && isClientExist && <div style={{marginTop:"10px", marginBottom:"15px"}}>
                    <AddCard
                      infoImage
                      cardDataCb={data =>
                        this.setState({ cardData: data })
                      }
                    />
                  </div>}

                  <button
                    className='service_check-btn'
                    disabled={!isAmountCorrect && isClientExist}
                  >
                    {isClientExist ? language.pay : language.check}
                  </button>
                </form>
                {(this.state.isLoading ||
                  this.props.loading.isLoading ||
                  this.props.loading.isPaymentLoading) &&
                  loader}
              </div>
              {(service.localDesc[langKey] ||
                this.state.additionalDebtFields?.length !== 0) && (
                <aside className='right-column'>
                  {service.localDesc[langKey] && (
                    <div
                      className='service_fields-item service_description-field'
                      dangerouslySetInnerHTML={{
                        __html: serviceDescription,
                      }}
                    ></div>
                  )}
                  {this.state.additionalDebtFields?.length !== 0 && (
                    <div className='service_fields-item service_debt-additional-field-items'>
                      {this.state.additionalDebtFields?.map((item, index) => {
                        return (
                          <div
                            className='service_debt-additional-field-item'
                            key={index}
                          >
                            <div className='service_debt-additional-field-item-title'>
                              {item.mutliLangValueString[langKey].replace(
                                /<[^>]+>/g,
                                ' ',
                              )}
                            </div>
                            <div className='service_debt-additional-field-item-body'>
                              {item.value}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )}
                </aside>
              )}
            </div>
          </div>
          <Footer containerClassName={containerClassName} />
        </div>
        <ToastContainer />
      </>
    )
  }
}

const mapStateToProps = state => {
  console.log(`mapStateToProps state:`, state)
  const {
    service: { service, serviceError },
    browserToken: { browserToken },
    loading,
    language,
    guestPayment,
  } = state
  return {
    service,
    loading,
    serviceError,
    language,
    guestPayment,
    browserToken,
  }
}

const mapDispatchToProps = {
  getServiceById: ServiceActionCreators.getServiceById,
  doGuestPay: GuestActionCreators.doGuestPay,
  getBrowserToken: BrowserTokenActionCreators.getBrowserToken,
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Service))
